import { Drawer, IconButton, styled } from "@mui/material";
import { CardContainer } from "./../../../components/CardContainer";
import { Box } from "@mui/system";
import { themeShadows } from "../../../theme/themeColors";

export const ChatContainer = styled(CardContainer)(() => ({
  padding: 0,
  display: "flex",
  maxHeight: "700px",
}));

export const ChatHeader = styled(Box)(({ theme }) => ({
  height: "50px",
  padding: "5px 15px",
  boxShadow: themeShadows[1],
}));

export const ChatListBox = styled(Box)(({ theme }) => ({
  width: "280px",
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: "10px",
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

export const ChatInboxContainer = styled(Box)(({ theme }) => ({
  width: "calc(100% - 280px)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const ChatBody = styled(Box)(({ theme }) => ({
  height: "100%",
  padding: "2rem",
  overflowY: "auto",
  position: "relative",
}));

export const ChatInboxFooter = styled(Box)(({ theme }) => ({
  height: "140px",
  padding: "15px 20px",
  boxShadow: themeShadows[1],
}));

export const ChatInput = styled("textarea")(({ theme }) => ({
  width: "100%",
  border: "none",
  padding: "10px",
  borderRadius: "15px",
  transition: "all 0.2s",
  background: theme.palette.grey[100],
  boxShadow: `0px 0px 1px 1px ${theme.palette.grey[500]}`,
  "&:focus": {
    border: "none",
    outline: "none",
    transition: "all 0.2s",
    boxShadow: `0px 0px 1px 3px ${theme.palette.primary.light}`,
  },
}));

export const ChatListDrawer = styled(Drawer)(({ theme }) => ({
  flexShrink: 0,
  width: 240,
  "& .MuiDrawer-paper": {
    width: 240,
    zIndex: 100,
    border: "none",
    marginTop: "50px",
    position: "absolute",
    left: 0,
  },
}));
